<template>
    <div id="contenedor-listado-mobiles">
        <template
            v-for="(tipoObra, index) in listadoTiposObras">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ tipoObra.descripcion }}
                  </div>
                </v-card-title>
                <v-card-text>
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
// import Opciones from './Opciones.vue';

export default {
  name: 'ListadoTiposObrasMobiles',
  props: {
    listadoTiposObras: {
      type: Array,
      requited: true,
    },
  },
  components: {
    // Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
